import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import { api } from './api/reducer';

export const store = configureStore({
  reducer: {
    api,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.abortController', 'payload.data'],
        // Ignore these paths in the state
        ignoredPaths: ['api'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = any> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
